/**
 * CSS Constants
 */
/** @hidden */
export var ROOT = 'e-schedule';
/** @hidden */
export var RTL = 'e-rtl';
/** @hidden */
export var DEVICE_CLASS = 'e-device';
/** @hidden */
export var ICON = 'e-icons';
/** @hidden */
export var ENABLE_CLASS = 'e-enable';
/** @hidden */
export var DISABLE_CLASS = 'e-disable';
/** @hidden */
export var TABLE_CONTAINER_CLASS = 'e-table-container';
/** @hidden */
export var SCHEDULE_TABLE_CLASS = 'e-schedule-table';
/** @hidden */
export var ALLDAY_CELLS_CLASS = 'e-all-day-cells';
/** @hidden */
export var HEADER_POPUP_CLASS = 'e-header-popup';
/** @hidden */
export var HEADER_CALENDAR_CLASS = 'e-header-calendar';
/** @hidden */
export var ALLDAY_ROW_CLASS = 'e-all-day-row';
/** @hidden */
export var CONTENT_TABLE_CLASS = 'e-content-table';
/** @hidden */
export var WORK_CELLS_CLASS = 'e-work-cells';
/** @hidden */
export var WORK_HOURS_CLASS = 'e-work-hours';
/** @hidden */
export var POPUP_OPEN = 'e-popup-open';
/** @hidden */
export var POPUP_CLOSE = 'e-popup-close';
/** @hidden */
export var DATE_HEADER_WRAP_CLASS = 'e-date-header-wrap';
/** @hidden */
export var DATE_HEADER_CONTAINER_CLASS = 'e-date-header-container';
/** @hidden */
export var HEADER_CELLS_CLASS = 'e-header-cells';
/** @hidden */
export var WORKDAY_CLASS = 'e-work-days';
/** @hidden */
export var OTHERMONTH_CLASS = 'e-other-month';
/** @hidden */
export var CURRENT_DAY_CLASS = 'e-current-day';
/** @hidden */
export var CURRENTDATE_CLASS = 'e-current-date';
/** @hidden */
export var CURRENT_PANEL_CLASS = 'e-current-panel';
/** @hidden */
export var PREVIOUS_PANEL_CLASS = 'e-previous-panel';
/** @hidden */
export var NEXT_PANEL_CLASS = 'e-next-panel';
/** @hidden */
export var PREVIOUS_DATE_CLASS = 'e-prev';
/** @hidden */
export var NEXT_DATE_CLASS = 'e-next';
/** @hidden */
export var TRANSLATE_CLASS = 'e-translate';
/** @hidden */
export var LEFT_INDENT_CLASS = 'e-left-indent';
/** @hidden */
export var LEFT_INDENT_WRAP_CLASS = 'e-left-indent-wrap';
/** @hidden */
export var EVENT_TABLE_CLASS = 'e-event-table';
/** @hidden */
export var RESOURCE_LEFT_TD_CLASS = 'e-resource-left-td';
/** @hidden */
export var RESOURCE_GROUP_CELLS_CLASS = 'e-resource-group-cells';
/** @hidden */
export var RESOURCE_TEXT_CLASS = 'e-resource-text';
/** @hidden */
export var RESOURCE_COLUMN_WRAP_CLASS = 'e-resource-column-wrap';
/** @hidden */
export var RESOURCE_COLUMN_TABLE_CLASS = 'e-resource-column-table';
/** @hidden */
export var RESOURCE_CHILD_CLASS = 'e-child-node';
/** @hidden */
export var RESOURCE_PARENT_CLASS = 'e-parent-node';
/** @hidden */
export var RESOURCE_EXPAND_CLASS = 'e-resource-expand';
/** @hidden */
export var RESOURCE_COLLAPSE_CLASS = 'e-resource-collapse';
/** @hidden */
export var RESOURCE_TREE_ICON_CLASS = 'e-resource-tree-icon';
/** @hidden */
export var RESOURCE_CELLS_CLASS = 'e-resource-cells';
/** @hidden */
export var TIME_CELLS_WRAP_CLASS = 'e-time-cells-wrap';
/** @hidden */
export var TIME_CELLS_CLASS = 'e-time-cells';
/** @hidden */
export var TIME_SLOT_CLASS = 'e-time-slots';
/** @hidden */
export var ALTERNATE_CELLS_CLASS = 'e-alternate-cells';
/** @hidden */
export var CURRENT_TIME_CLASS = 'e-current-time';
/** @hidden */
export var CURRENT_TIMELINE_CLASS = 'e-current-timeline';
/** @hidden */
export var PREVIOUS_TIMELINE_CLASS = 'e-previous-timeline';
/** @hidden */
export var HIDE_CHILDS_CLASS = 'e-hide-childs';
/** @hidden */
export var SCROLL_CONTAINER_CLASS = 'e-scroll-container';
/** @hidden */
export var WRAPPER_CLASS = 'e-wrapper';
/** @hidden */
export var TIMELINE_WRAPPER_CLASS = 'e-timeline-wrapper';
/** @hidden */
export var APPOINTMENT_WRAPPER_CLASS = 'e-appointment-wrapper';
/** @hidden */
export var DAY_WRAPPER_CLASS = 'e-day-wrapper';
/** @hidden */
export var TOOLBAR_CONTAINER = 'e-schedule-toolbar-container';
/** @hidden */
export var RESOURCE_TOOLBAR_CONTAINER = 'e-schedule-resource-toolbar-container';
/** @hidden */
export var HEADER_TOOLBAR = 'e-schedule-toolbar';
/** @hidden */
export var RESOURCE_HEADER_TOOLBAR = 'e-schedule-resource-toolbar';
/** @hidden */
export var SELECTED_CELL_CLASS = 'e-selected-cell';
/** @hidden */
export var WEEK_NUMBER_WRAPPER_CLASS = 'e-week-number-wrapper';
/** @hidden */
export var WEEK_NUMBER_CLASS = 'e-week-number';
/** @hidden */
export var APPOINTMENT_WRAP_CLASS = 'e-appointment-wrap';
/** @hidden */
export var WRAPPER_CONTAINER_CLASS = 'e-wrapper-container';
/** @hidden */
export var APPOINTMENT_CONTAINER_CLASS = 'e-appointment-container';
/** @hidden */
export var APPOINTMENT_CLASS = 'e-appointment';
/** @hidden */
export var BLOCK_APPOINTMENT_CLASS = 'e-block-appointment';
/** @hidden */
export var BLOCK_INDICATOR_CLASS = 'e-block-indicator';
/** @hidden */
export var APPOINTMENT_BORDER = 'e-appointment-border';
/** @hidden */
export var APPOINTMENT_DETAILS = 'e-appointment-details';
/** @hidden */
export var SUBJECT_WRAP = 'e-subject-wrap';
/** @hidden */
export var RESOURCE_NAME = 'e-resource-name';
/** @hidden */
export var APPOINTMENT_TIME = 'e-time';
/** @hidden */
export var TABLE_WRAP_CLASS = 'e-table-wrap';
/** @hidden */
export var OUTER_TABLE_CLASS = 'e-outer-table';
/** @hidden */
export var CONTENT_WRAP_CLASS = 'e-content-wrap';
/** @hidden */
export var VIRTUAL_TRACK_CLASS = 'e-virtual-track';
/** @hidden */
export var AGENDA_CELLS_CLASS = 'e-agenda-cells';
/** @hidden */
export var AGENDA_CURRENT_DAY_CLASS = 'e-current-day';
/** @hidden */
export var AGENDA_SELECTED_CELL = 'e-active-appointment-agenda';
/** @hidden */
export var MONTH_HEADER_CLASS = 'e-month-header';
/** @hidden */
export var AGENDA_HEADER_CLASS = 'e-day-date-header';
/** @hidden */
export var AGENDA_RESOURCE_CLASS = 'e-resource-column';
/** @hidden */
export var AGENDA_DATE_CLASS = 'e-date-column';
/** @hidden */
export var NAVIGATE_CLASS = 'e-navigate';
/** @hidden */
export var DATE_HEADER_CLASS = 'e-date-header';
/** @hidden */
export var AGENDA_DAY_BORDER_CLASS = 'e-day-border';
/** @hidden */
export var DATE_BORDER_CLASS = 'e-date-border';
/** @hidden */
export var AGENDA_DAY_PADDING_CLASS = 'e-day-padding';
/** @hidden */
export var DATE_TIME_CLASS = 'e-date-time';
/** @hidden */
export var DATE_TIME_WRAPPER_CLASS = 'e-date-time-wrapper';
/** @hidden */
export var AGENDA_EMPTY_EVENT_CLASS = 'e-empty-event';
/** @hidden */
export var AGENDA_NO_EVENT_CLASS = 'e-no-event';
/** @hidden */
export var APPOINTMENT_INDICATOR_CLASS = 'e-appointment-indicator';
/** @hidden */
export var EVENT_INDICATOR_CLASS = 'e-indicator';
/** @hidden */
export var EVENT_ICON_UP_CLASS = 'e-up-icon';
/** @hidden */
export var EVENT_ICON_DOWN_CLASS = 'e-down-icon';
/** @hidden */
export var EVENT_ICON_LEFT_CLASS = 'e-left-icon';
/** @hidden */
export var EVENT_ICON_RIGHT_CLASS = 'e-right-icon';
/** @hidden */
export var EVENT_ACTION_CLASS = 'e-event-action';
/** @hidden */
export var NEW_EVENT_CLASS = 'e-new-event';
/** @hidden */
export var CLONE_ELEMENT_CLASS = 'e-schedule-event-clone';
/** @hidden */
export var MONTH_CLONE_ELEMENT_CLASS = 'e-month-event';
/** @hidden */
export var CLONE_TIME_INDICATOR_CLASS = 'e-clone-time-indicator';
/** @hidden */
export var DRAG_CLONE_CLASS = 'e-drag-clone';
/** @hidden */
export var EVENT_RESIZE_CLASS = 'e-event-resize';
/** @hidden */
export var RESIZE_CLONE_CLASS = 'e-resize-clone';
/** @hidden */
export var LEFT_RESIZE_HANDLER = 'e-left-handler';
/** @hidden */
export var RIGHT_RESIZE_HANDLER = 'e-right-handler';
/** @hidden */
export var TOP_RESIZE_HANDLER = 'e-top-handler';
/** @hidden */
export var BOTTOM_RESIZE_HANDLER = 'e-bottom-handler';
/** @hidden */
export var EVENT_RECURRENCE_ICON_CLASS = 'e-recurrence-icon';
/** @hidden */
export var EVENT_RECURRENCE_EDIT_ICON_CLASS = 'e-recurrence-edit-icon';
/** @hidden */
export var HEADER_ROW_CLASS = 'e-header-row';
/** @hidden */
export var ALLDAY_APPOINTMENT_WRAPPER_CLASS = 'e-all-day-appointment-wrapper';
/** @hidden */
export var ALLDAY_APPOINTMENT_CLASS = 'e-all-day-appointment';
/** @hidden */
export var EVENT_COUNT_CLASS = 'e-appointment-hide';
/** @hidden */
export var ROW_COUNT_WRAPPER_CLASS = 'e-row-count-wrapper';
/** @hidden */
export var ALLDAY_APPOINTMENT_SECTION_CLASS = 'e-all-day-appointment-section';
/** @hidden */
export var APPOINTMENT_ROW_EXPAND_CLASS = 'e-appointment-expand';
/** @hidden */
export var APPOINTMENT_ROW_COLLAPSE_CLASS = 'e-appointment-collapse';
/** @hidden */
export var MORE_INDICATOR_CLASS = 'e-more-indicator';
/** @hidden */
export var CELL_POPUP_CLASS = 'e-cell-popup';
/** @hidden */
export var EVENT_POPUP_CLASS = 'e-event-popup';
/** @hidden */
export var MULTIPLE_EVENT_POPUP_CLASS = 'e-multiple-event-popup';
/** @hidden */
export var POPUP_HEADER_CLASS = 'e-popup-header';
/** @hidden */
export var POPUP_HEADER_ICON_WRAPPER = 'e-header-icon-wrapper';
/** @hidden */
export var POPUP_CONTENT_CLASS = 'e-popup-content';
/** @hidden */
export var POPUP_FOOTER_CLASS = 'e-popup-footer';
/** @hidden */
export var DATE_TIME_DETAILS_CLASS = 'e-date-time-details';
/** @hidden */
export var RECURRENCE_SUMMARY_CLASS = 'e-recurrence-summary';
/** @hidden */
export var QUICK_POPUP_EVENT_DETAILS_CLASS = 'e-event-details';
/** @hidden */
export var EVENT_CREATE_CLASS = 'e-event-create';
/** @hidden */
export var EDIT_EVENT_CLASS = 'e-event-edit';
/** @hidden */
export var DELETE_EVENT_CLASS = 'e-event-delete';
/** @hidden */
export var TEXT_ELLIPSIS = 'e-text-ellipsis';
/** @hidden */
export var MORE_POPUP_WRAPPER_CLASS = 'e-more-popup-wrapper';
/** @hidden */
export var MORE_EVENT_POPUP_CLASS = 'e-more-event-popup';
/** @hidden */
export var MORE_EVENT_HEADER_CLASS = 'e-more-event-header';
/** @hidden */
export var MORE_EVENT_DATE_HEADER_CLASS = 'e-more-event-date-header';
/** @hidden */
export var MORE_EVENT_HEADER_DAY_CLASS = 'e-header-day';
/** @hidden */
export var MORE_EVENT_HEADER_DATE_CLASS = 'e-header-date';
/** @hidden */
export var MORE_EVENT_CLOSE_CLASS = 'e-more-event-close';
/** @hidden */
export var MORE_EVENT_CONTENT_CLASS = 'e-more-event-content';
/** @hidden */
export var MORE_EVENT_WRAPPER_CLASS = 'e-more-appointment-wrapper';
/** @hidden */
export var QUICK_DIALOG_CLASS = 'e-quick-dialog';
/** @hidden */
export var QUICK_DIALOG_OCCURRENCE_CLASS = 'e-quick-dialog-occurrence-event';
/** @hidden */
export var QUICK_DIALOG_SERIES_CLASS = 'e-quick-dialog-series-event';
/** @hidden */
export var QUICK_DIALOG_FOLLOWING_EVENTS_CLASS = 'e-quick-dialog-following-events';
/** @hidden */
export var FOLLOWING_EVENTS_DIALOG = 'e-following-events-dialog';
/** @hidden */
export var QUICK_DIALOG_DELETE_CLASS = 'e-quick-dialog-delete';
/** @hidden */
export var QUICK_DIALOG_CANCEL_CLASS = 'e-quick-dialog-cancel';
/** @hidden */
export var QUICK_DIALOG_ALERT_OK = 'e-quick-alertok';
/** @hidden */
export var QUICK_DIALOG_ALERT_CANCEL = 'e-quick-alertcancel';
/** @hidden */
export var QUICK_DIALOG_ALERT_FOLLOWING = 'e-quick-alertfollowing';
/** @hidden */
export var QUICK_DIALOG_ALERT_BTN_CLASS = 'e-quick-dialog-alert-btn';
/** @hidden */
export var EVENT_WINDOW_DIALOG_CLASS = 'e-schedule-dialog';
/** @hidden */
export var FORM_CONTAINER_CLASS = 'e-form-container';
/** @hidden */
export var FORM_CLASS = 'e-schedule-form';
/** @hidden */
export var EVENT_WINDOW_ALLDAY_TZ_DIV_CLASS = 'e-all-day-time-zone-row';
/** @hidden */
export var EVENT_WINDOW_ALL_DAY_CLASS = 'e-all-day';
/** @hidden */
export var TIME_ZONE_CLASS = 'e-time-zone';
/** @hidden */
export var TIME_ZONE_ICON_CLASS = 'e-time-zone-icon';
/** @hidden */
export var TIME_ZONE_DETAILS_CLASS = 'e-time-zone-details';
/** @hidden */
export var EVENT_WINDOW_REPEAT_DIV_CLASS = 'e-repeat-parent-row';
/** @hidden */
export var EVENT_WINDOW_REPEAT_CLASS = 'e-repeat';
/** @hidden */
export var EVENT_WINDOW_TITLE_LOCATION_DIV_CLASS = 'e-title-location-row';
/** @hidden */
export var SUBJECT_CLASS = 'e-subject';
/** @hidden */
export var LOCATION_CLASS = 'e-location';
/** @hidden */
export var LOCATION_ICON_CLASS = 'e-location-icon';
/** @hidden */
export var LOCATION_DETAILS_CLASS = 'e-location-details';
/** @hidden */
export var EVENT_WINDOW_START_END_DIV_CLASS = 'e-start-end-row';
/** @hidden */
export var EVENT_WINDOW_START_CLASS = 'e-start';
/** @hidden */
export var EVENT_WINDOW_END_CLASS = 'e-end';
/** @hidden */
export var EVENT_WINDOW_RESOURCES_DIV_CLASS = 'e-resources-row';
/** @hidden */
export var DESCRIPTION_CLASS = 'e-description';
/** @hidden */
export var DESCRIPTION_ICON_CLASS = 'e-description-icon';
/** @hidden */
export var DESCRIPTION_DETAILS_CLASS = 'e-description-details';
/** @hidden */
export var EVENT_WINDOW_TIME_ZONE_DIV_CLASS = 'e-time-zone-row';
/** @hidden */
export var EVENT_WINDOW_START_TZ_CLASS = 'e-start-time-zone';
/** @hidden */
export var EVENT_WINDOW_END_TZ_CLASS = 'e-end-time-zone';
/** @hidden */
export var EVENT_WINDOW_BACK_ICON_CLASS = 'e-back-icon';
/** @hidden */
export var EVENT_WINDOW_SAVE_ICON_CLASS = 'e-save-icon';
/** @hidden */
export var EVENT_WINDOW_CANCEL_BUTTON_CLASS = 'e-event-cancel';
/** @hidden */
export var EVENT_WINDOW_SAVE_BUTTON_CLASS = 'e-event-save';
/** @hidden */
export var EVENT_WINDOW_DIALOG_PARENT_CLASS = 'e-dialog-parent';
/** @hidden */
export var EVENT_WINDOW_TITLE_TEXT_CLASS = 'e-title-text';
/** @hidden */
export var EVENT_WINDOW_ICON_DISABLE_CLASS = 'e-icon-disable';
/** @hidden */
export var EDIT_CLASS = 'e-edit';
/** @hidden */
export var EDIT_ICON_CLASS = 'e-edit-icon';
/** @hidden */
export var DELETE_CLASS = 'e-delete';
/** @hidden */
export var DELETE_ICON_CLASS = 'e-delete-icon';
/** @hidden */
export var CLOSE_CLASS = 'e-close';
/** @hidden */
export var CLOSE_ICON_CLASS = 'e-close-icon';
/** @hidden */
export var ERROR_VALIDATION_CLASS = 'e-schedule-error';
/** @hidden */
export var EVENT_TOOLTIP_ROOT_CLASS = 'e-schedule-event-tooltip';
/** @hidden */
export var ALLDAY_ROW_ANIMATE_CLASS = 'e-animate';
/** @hidden */
export var TIMESCALE_DISABLE = 'e-timescale-disable';
/** @hidden */
export var DISABLE_DATE = 'e-disable-date';
/** @hidden */
export var HIDDEN_CLASS = 'e-hidden';
/** @hidden */
export var DISABLE_DATES = 'e-disable-dates';
/** @hidden */
export var POPUP_WRAPPER_CLASS = 'e-quick-popup-wrapper';
/** @hidden */
export var POPUP_TABLE_CLASS = 'e-popup-table';
/** @hidden */
export var RESOURCE_MENU = 'e-resource-menu';
/** @hidden */
export var RESOURCE_MENU_ICON = 'e-icon-menu';
/** @hidden */
export var RESOURCE_LEVEL_TITLE = 'e-resource-level-title';
/** @hidden */
export var RESOURCE_TREE = 'e-resource-tree';
/** @hidden */
export var RESOURCE_TREE_POPUP_OVERLAY = 'e-resource-tree-popup-overlay';
/** @hidden */
export var RESOURCE_TREE_POPUP = 'e-resource-tree-popup';
/** @hidden */
export var RESOURCE_CLASS = 'e-resource';
/** @hidden */
export var RESOURCE_ICON_CLASS = 'e-resource-icon';
/** @hidden */
export var RESOURCE_DETAILS_CLASS = 'e-resource-details';
/** @hidden */
export var DATE_TIME_ICON_CLASS = 'e-date-time-icon';
/** @hidden */
export var VIRTUAL_SCROLL_CLASS = 'e-virtual-scroll';
/** @hidden */
export var ICON_DISABLE_CLASS = 'e-icon-disable';
/** @hidden */
export var AUTO_HEIGHT = 'e-auto-height';
/** @hidden */
export var IGNORE_WHITESPACE = 'e-ignore-whitespace';
/** @hidden */
export var EVENT_TEMPLATE = 'e-template';
/** @hidden */
export var READ_ONLY = 'e-read-only';
/** @hidden */
export var MONTH_HEADER_WRAPPER = 'e-month-header-wrapper';
